// La encuesta del agente en el lugar de la caja de texto
// (ADR-2026-10-22-la-encuesta-reemplaza-la-caja-de-texto, -2). Lo usan las tres pantallas que tienen
// su propia caja debajo de `MensajesDeLaConversacion`: el Chat (`ConversacionChatAtlas`), el
// Asistente de Crear (`PortadaDelAsistente`) y Redes (`PantallaRedes`). Cada una le pasa a
// `MensajesDeLaConversacion` `encuestaEnLaCaja` para que no la dibuje también arriba: si una pantalla
// la saca de ahí sin dibujarla acá, la encuesta no se ve y el turno queda esperando (pasó en Crear).

import { useState } from 'react';
import { ToolCardRenderer } from '../../pages/v2/ChatPanelV2';
import type { UseV2ChatReturn, V2ToolCard } from '../../pages/v2/useV2Chat';
import { encuestaEnLaCaja, esEncuesta } from './encuestaEnLaCaja';

/**
 * - `encuesta`: la que va en el lugar de la caja, o null.
 * - `escribeSobreLaEncuesta`: tocó "Prefiero escribirlo" en la que está esperando. El turno sigue "en
 *   curso" (espera esa encuesta): la caja tiene que MANDAR —el envío la suelta— en vez de encolar o
 *   mostrar Detener.
 */
export function useEncuestaEnLaCaja(motor: Pick<UseV2ChatReturn, 'activeToolCard'>) {
  const [escribirEn, setEscribirEn] = useState<string | null>(null);
  const activa = motor.activeToolCard;
  return {
    encuesta: encuestaEnLaCaja(activa, escribirEn),
    escribeSobreLaEncuesta: !!activa && esEncuesta(activa) && activa.id === escribirEn,
    preferirEscribir: (id: string) => setEscribirEn(id),
  };
}

/**
 * La encuesta, con el envoltorio blanco del slot de card activa. Más alta en el teléfono (80 % de la
 * pantalla): ahí las preguntas se apilan y con el 55 % de la computadora había que scrollear adentro
 * desde la segunda (ADR-2026-10-22-la-encuesta-reemplaza-la-caja-de-texto-3).
 */
export const EncuestaEnLaCaja: React.FC<{
  encuesta: V2ToolCard;
  motor: UseV2ChatReturn;
  onPreferirEscribir: () => void;
}> = ({ encuesta, motor, onPreferirEscribir }) => (
  <div
    key={encuesta.id}
    className="animate-mode-swap max-h-[80dvh] overflow-y-auto rounded-2xl bg-white shadow-[0_2px_14px_-6px_rgba(0,0,0,0.12),0_1px_3px_rgba(0,0,0,0.04)] ring-1 ring-black/[0.04] md:max-h-[55dvh]"
  >
    <ToolCardRenderer card={encuesta} chat={motor} embedded onPreferirEscribir={onPreferirEscribir} />
  </div>
);
